<template>
<div id="statistics-tab" class="container">
    <div class="row head">
        <div class="period">
            <span>{{ getPeriod() }}</span>
        </div>

        <div @click="changePeriod(-1)" class="button button-center btn-period" :class="{'inactive':  period == 'week'}">
            <i class="iconify icon:mdi:chevron-left"></i>
        </div>

        <div @click="changePeriod(+1)" class="button button-center btn-period" :class="{'inactive':  period == 'year'}">
            <i class="iconify icon:mdi:chevron-right"></i>
        </div>

        <div class="country pull-right" @click="showCountrySelector = true">{{ countrySelected.name }}</div>
    </div>

    <div class="row tabs">
        <div v-for="(v, provider) in views" class="tab" @click="changeTab(provider)" :class="{'active' : activeTab == provider}" v-if="provider != 'spotify'">
            <div class="name" v-html="getName(provider)"></div>
            <div class="total">
                <animated-number :value="views[provider].show" :duration="500" :formatValue="formatToNumber" v-if="views[provider].show != -9999"/>
                <span v-else>Ø</span>
            </div>
            <div class="evolution" v-if="provider != 'spotify_playlists'">
                <div v-if="views[provider].yesterday != -9999 || views[provider].evolution != -9999">
                    <span class="yesterday" v-if="views[provider].yesterday != -9999"><animated-number :value="views[provider].yesterday" :duration="500" :formatValue="formatToNumber"/></span>
                    <span class="yesterday" v-else>Ø</span>
                     / 
                    <span v-if="views[provider].evolution != -9999" class="value" :class="{'text-green': views[provider].evolution > 0, 'text-red': views[provider].evolution < 0 && views[provider].evolution > -9999}">
                        <animated-number :value="views[provider].evolution" :duration="500" :formatValue="formatToProcent"/>
                    </span>
                    <span v-else class="value">Ø</span>
                </div>
                <div v-else>
                    TOTAL
                </div>
            </div>

            <div v-else class="evolution">
                <span><animated-number :value="views.spotify_playlists.total" :duration="500" :formatValue="formatToNumber"/> FOLLOWERS</span>
            </div>
            <img :src="getIcon(provider)" alt=""/>
        </div> 
    </div>

    <div class="row items">
        <panel                   :events="events" :song="song" :period="period" :filter="filter" :country="countrySelected" media="youtube" v-show="activeTab == 'youtube'" :selected="activeTab"></panel>
        <panel                   :events="events" :song="song" :period="period" :filter="filter" :country="countrySelected" media="spotify_plays" v-show="activeTab == 'spotify_plays'" :selected="activeTab"></panel>
        <panel                   :events="events" :song="song" :period="period" :filter="filter" :country="countrySelected" media="shazam" v-show="activeTab == 'shazam'" :selected="activeTab"></panel>
        <panel                   :events="events" :song="song" :period="period" :filter="filter" :country="countrySelected" media="warm_music" v-show="activeTab == 'warm_music'" :selected="activeTab"></panel>
        <panel-spotify-playlists :events="events" :song="song" :period="period" :filter="filter" :country="countrySelected" media="spotify_playlists" :views="views" v-show="activeTab == 'spotify_playlists'" :selected="activeTab"></panel-spotify-playlists>
        <panel                   :events="events" :song="song" :period="period" :filter="filter" :country="countrySelected" media="soundcloud" v-show="activeTab == 'soundcloud'" :selected="activeTab"></panel>
        <panel                   :events="events" :song="song" :period="period" :filter="filter" :country="countrySelected" media="apple_music" v-show="activeTab == 'apple_music'" :selected="activeTab"></panel>
    </div>

    <div class="move-to-root">
        <transition name="page-overlay">
            <div class="page-overlay country-selector" :id="oid" v-show="showCountrySelector">
                <div class="container">
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="btn-close button button-center pull-left" @click="showCountrySelector = false">
                                <i class="iconify" data-icon="ic:outline-chevron-left" data-inline="false"></i>
                            </div>
                        </div>

                        <div class="col-xs-12 content">
                            <input type="text" class="search-filters" placeholder="Search countries" v-model="search">
                            <i class="iconify" data-icon="ic:sharp-search"></i>

                            <h3>Select Country</h3>

                            <ul class="list countries">
                                <li v-for="country in countries" class="button col-xs-4" @click="changeCountry(country)" :class="{'selected' : countrySelected.code == country.code, 'worldwide': !country.code }">{{ country.name }}</li>
                            </ul>
                        </div>

                        <div class="col-xs-12 text-center">
                            <div class="btn btn-default btn-outline button btn-back" @click="showCountrySelector = false">BACK</div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>

</div>
</template>

<script>
import AnimatedNumber from "animated-number-vue";  
export default {
    components: {
        AnimatedNumber,
        'panel': require('@/components/Song/Show/Tab/Statistics/ProviderPanel.vue').default,
        'panel-spotify-playlists': require('@/components/Song/Show/Tab/Statistics/SpotifyPlaylistsPanel.vue').default,
    },

    props: ['song'],

    data() {
        return {
            views: {
                // allchannels: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                youtube: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                spotify_plays: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                shazam: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                warm_music: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                spotify_playlists: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                soundcloud: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
                apple_music: { total: -9999, partial: -9999, show: -9999, yesterday: -9999, evolution: -9999, evolution_type: null},
            },

            events: false,
            activeTab: false,
            oid: "country_selector_"+ Math.random().toString(36).substr(2, 9),

            countries: [{ name: 'Worldwide', code: 0 }],
            countrySelected: { name: 'Worldwide', code: 0 },
            showCountrySelector : false,
            search: '',

            filter: 'daily',
            period: 'week',
        }
    },

    mounted() {
        this.changeTab('youtube');
        this.getEvents();
        this.getViews();
        this.getAvailableCountries();

        this.$on('evolution-update', (media, datasets, views_sum) => {
            this.views[media].total = views_sum ? views_sum : this.views[media].total;
            this.views[media].partial = datasets.length ? eval(datasets.join("+")) : -9999;
            this.views[media].show = this.period != 'year' || this.countrySelected.code ? this.views[media].partial : this.views[media].total;

            // evolution?
            if (datasets && datasets.length > 1){
                var thisTick = datasets[datasets.length - 1];
                var lastTick = datasets[datasets.length - 2];

                this.views[media].yesterday = thisTick;
                this.views[media].evolution = lastTick ? (thisTick - lastTick) / lastTick * 100 : 0;
            }else{
                this.views[media].yesterday = -9999;
                this.views[media].evolution = -9999;
            }
        });

        this.$root.$on('country-click', (name) => {
            if (this.countrySelected.name.toLowerCase() == name.toLowerCase()){
                this.countrySelected = { name: 'Worldwide', code: 0 };
                return;
            }

            $.each(this.countries, (i,c) => {
                if (c.name.toLowerCase() == name.toLowerCase()){
                    this.countrySelected = c;
                }
            })
        });          
    },
 
    methods: {
        getAvailableCountries(){
            var countries = App.filters.raw.countries.sort((a, b) => {
                var aName = a.name.toLowerCase();
                var bName = b.name.toLowerCase(); 
                return ((aName < bName) ? -1 : ((aName > bName) ? 1 : 0));
            });

            $.each(countries, (i, c) => {
                this.countries.push({name: c.name, code: c.alpha_two.toLowerCase(), id: c.id});
            });
        },

        formatToNumber(value) {
            if (value == -9999){ return "0"; }

            if (value > 1000000) return (value/1000000).toFixed(1) +"<small>M</small>";
            if (value > 1000) return (value/1000).toFixed(1) +"<small>K</small>";
            if (value >= 0) return +value.toFixed(0);
            return "0";
        },

        formatToProcent(value){
            return value == -9999 ? "Ø" : value.toFixed(1).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") + `%`;
        },

        changeTab(tab){
            this.activeTab = tab;

            if (App.allowGtag) gtag('config', 'UA-152097964-2', {
                'page_path' : '/song/statistics/' + tab,
                'page_location': '/song/statistics/' + tab,
                'page_title' : `${ this.isOwner ? 'Own' : 'Other'} Song > Statistics > ${ this.getName(tab) }`,
            });
        },

        changeCountry(country){
            this.countrySelected = country; 
            this.showCountrySelector = false;
        },

        changePeriod(direction){
            if (direction == 1){
                if (this.period == 'months') { this.period = 'year'; this.filter = 'monthly'; }
                else if (this.period == 'month') { this.period = 'months'; this.filter = 'weekly'; }
                else if (this.period == 'week') { this.period = 'month'; this.filter = 'daily'; }
                // else if (this.period == 'day') { this.period = 'week'; this.filter = 'daily'; }
            }

            if (direction == -1){
                if (this.period == 'year') { this.period = 'months'; this.filter = 'weekly'; }
                else if (this.period == 'months') { this.period = 'month'; this.filter = 'daily'; }
                else if (this.period == 'month') { this.period = 'week'; this.filter = 'daily'; }
                // else if (this.period == 'week') { this.period = 'day'; this.filter = 'daily'; }
            }
        },
 
        getEvents(){
            this.$http.get(App.restApi + '/api/song/' + this.song.id + '/events').then((success) => {
                this.events = success.data.data;
            });
        },

        getViews() {
            this.$http.get(App.restApi + '/api/song/' + this.song.id + '/views').then((success) => {
                var data = success.data.data;

                $.each(this.views, (media) => {
                    this.views[media].total = data[media] && data[media].count ? data[media].count * 1 : -9999;
                })
            });
        },

        getPeriod(){
            switch (this.period){
                case 'year':   return 'All Time'; break;
                case 'months': return 'Last 3 Months'; break;
                case 'month':  return 'Last Month'; break;
                case 'week':   return 'Last Week'; break;
                case 'day':    return 'Yesterday'; break;
            }
        },

        getFilter(){
            switch (this.filter){
                case 'monthly':   return 'Monthly'; break;
                case 'weekly': return 'Weekly'; break;
                case 'daily':  return 'Daily'; break;
            }
        },

        getName(provider){
            switch (provider){
                case 'spotify_plays': return 'Spotify'; break;
                case 'spotify_playlists': return 'Spotify Playlists'; break;
                case 'warm_music': return 'Radio'; break;
                case 'apple_music': return 'Apple Music'; break;
                default: return provider;
            }  
        },

        getIcon(provider){
            switch (provider){
                case 'spotify_plays': return '/img/web/song/statistics/spotify.svg'; break;
                case 'spotify_playlists': return '/img/web/song/statistics/spotify.svg'; break;
                default: return `/img/web/song/statistics/${provider}.svg`;
            }            
        }
    },

    computed: {
        isOwner(){
            return this.song.uploader_id == App.user.id;
        },        
    },

    watch: {
        activeTab(_new, _old){
            if (_old == false) return;
            
            this.$nextTick(() => {
                var scrollLeft = $('#page-song #statistics-tab .tabs .tab.active').position().left + $('#page-song #statistics-tab .tabs').scrollLeft() - 30;
                $('#page-song #statistics-tab .tabs').animate({ scrollLeft: scrollLeft }, 500);

                $('.item-container').scrollLeft(0);
                $('main').animate({ scrollTop: $('main')[0].scrollHeight }, 750);
            });
        },

        showCountrySelector(){
            this.search = '';
            if (this.showCountrySelector == false){
                setTimeout(() => {
                    $('.page-content').addClass('hasFooter');
                    this.$root.$emit('unlockScroll');

                    this.$nextTick(() => {
                        $('main').animate({ scrollTop: $('main').scrollTop() + $('#footer').height()}, 250);    
                    });
                }, 500);
            }else{
                $('.page-content').removeClass('hasFooter');
                this.$root.$emit('lockScroll');
            }
        },

        search(){
            var qString = this.search;
            $('.page-overlay.country-selector .list li').each((i,e) => {
                if ($(e).text().toLowerCase().indexOf( qString.toLowerCase() ) == -1 && qString.length){
                    $(e).hide();
                }else{
                   $(e).show();
                }
            })
        }
    },

    beforeDestroy() {
        $(`#${this.oid}`).remove();
    }
}
</script>